module.exports = __webpack_public_path__ + "img/gq.7c78f7e1.svg";